// /////////////////////////////////////////////////////

let bottomBar = document.createElement('div');
bottomBar.classList.add('bottomBar')


let bottomBarText = document.createElement('p');
bottomBarText.classList.add('bottomBarText');

jQuery.getJSON('/cart.js', function(cart) {
  bottomBarText.innerHTML = `تم إضافة <span class="cart-count">${cart.item_count }</span> منتجات إلى سلتك`;
 

} );

let bottomBarBtn = document.createElement('a');
bottomBarBtn.classList.add('header-cart-btn', 'cart-toggle', 'bottomBarBtn');
bottomBarBtn.href = '/cart'
bottomBarBtn.textContent = 'شاهد المنتجات';
bottomBarBtn.style.display = 'block'
bottomBar.appendChild(bottomBarText);
bottomBar.appendChild(bottomBarBtn);

// document.body.appendChild(bottomBar);
document.querySelector('.wrapper.main-content').append(bottomBar)

jQuery.getJSON('/cart.js', function(cart) {
if(cart.item_count > 0) { jQuery(".bottomBar").css('bottom','0') }
  } );

window.onscroll = _ => {
  if(window.scrollY >= 10) {
    jQuery(".free-shipping.large.site-header--text-links").addClass('sticky-top-bar');
  } else {
    jQuery(".free-shipping.large.site-header--text-links").removeClass('sticky-top-bar');
  }
}

window.onresize = _ => {
  if(window.innerWidth > 768)
  {
    window.onscroll = _ => {
      if(window.scrollY >= 10) {
        jQuery(".free-shipping.large.site-header--text-links").addClass('sticky-top-bar');
      } else {
        jQuery(".free-shipping.large.site-header--text-links").removeClass('sticky-top-bar');
      }

    }
  }
}

function checkoutproduct(pid,event){
    event.preventDefault(); 
    itemId = pid;
    quantity = 1;
    Shopify.addItem(itemId, quantity, function (cart) {
        jQuery(".bottomBar").css('bottom','0')

      $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart){
        var cartCount = cart.item_count;
        jQuery(".bottomBarText .cart-count").text(cartCount) ;
        bottomBarText.innerHTML = `تم إضافة <span class="cart-count">${cart.item_count }</span> منتجات إلى سلتك`;
      }
      });
    });
      window.location.href= '/checkout'
}

function addProductToAjaxCart(itemId) {  
  quantity = 1;
  Shopify.addItem(itemId, quantity, function () {
    Shopify.getCart(function (cart) {
      jQuery('.cart-count').css('display','inline-block')
      jQuery(".bottomBar").css('bottom','0')
      
      jQuery(".bottomBarText .cart-count").text(cart.item_count);
      bottomBarText.innerHTML = `تم إضافة <span class="cart-count">${cart.item_count }</span> منتجات إلى سلتك`;
      jQuery('.cart-count').text(cart.item_count);

      jQuery('#ajaxifyCart').load('/cart .cart-form');
      jQuery('#ajaxifyCart').addClass('cart-update')
 
  });
  });
}

function customAddToCart(dataLine,event) {
  event.preventDefault();         
  Shopify.changeItem(dataLine, 0,function(){
    customUpdateCart() 
    
  });
}

function changeQuantity(dataLine) {
  let theElementQu = jQuery(`[data-line=${dataLine}]`)[1].value
   Shopify.changeItem(dataLine, theElementQu,function(){
        customUpdateCart() 
  });

}

function customUpdateCart() {
    Shopify.getCart(function (cart) {  // 1
    if(cart.item_count < 1) { jQuery("#ajaxifyDrawer").css('height','0').removeClass('is-visible'); jQuery('.cart-count').css('display','none') }
      jQuery(".bottomBarText .cart-count").text(cart.item_count);
      bottomBarText.innerHTML = `تم إضافة <span class="cart-count">${cart.item_count }</span> منتجات إلى سلتك`;
      jQuery('.cart-count').text(cart.item_count);

      jQuery('#ajaxifyCart').load('/cart .cart-form');
      jQuery('#ajaxifyCart').addClass('cart-update')
  });
}